// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"581":"grab","594":"about"}[chunkId] + "." + {"581":"84c2bdb4","594":"8f651508"}[chunkId] + ".js";
};